/* Mondō London - progressively enhanced Archive register. */
(function () {
  'use strict';

  var PREVIEW_CACHE_LIMIT = 12;

  function initArchive(root) {
    if (!root || root._archiveDestroy) return;

    var previewLayout = window.matchMedia
      ? window.matchMedia('(min-width: 900px)')
      : { matches: true };

    /* The plate is a desktop enhancement. Keep mobile to ordinary linked
       records, with no observer or preview-image work, and remount cleanly
       when a tablet changes orientation. */
    if (!previewLayout.matches) {
      var awaitPreviewLayout = function (event) {
        if (!event.matches) return;
        if (previewLayout.removeEventListener) previewLayout.removeEventListener('change', awaitPreviewLayout);
        else if (previewLayout.removeListener) previewLayout.removeListener(awaitPreviewLayout);
        root._archiveDestroy = null;
        initArchive(root);
      };

      if (previewLayout.addEventListener) previewLayout.addEventListener('change', awaitPreviewLayout);
      else if (previewLayout.addListener) previewLayout.addListener(awaitPreviewLayout);

      root._archiveDestroy = function () {
        if (previewLayout.removeEventListener) previewLayout.removeEventListener('change', awaitPreviewLayout);
        else if (previewLayout.removeListener) previewLayout.removeListener(awaitPreviewLayout);
        root._archiveDestroy = null;
      };
      return;
    }

    var register = root.querySelector('[data-archive-register]');
    var plate = root.querySelector('[data-archive-plate]');
    var records = register
      ? Array.prototype.slice.call(register.querySelectorAll('[data-archive-record]'))
      : [];
    if (!register || !plate || !records.length || !('IntersectionObserver' in window)) return;

    var plateImageFrame = plate.querySelector('[data-archive-plate-image]');
    var previewImage = plate.querySelector('[data-archive-preview-image]');
    var previewEmpty = plate.querySelector('[data-archive-preview-empty]');
    if (!plateImageFrame || !previewImage || !previewEmpty) return;

    var previewPosition = plate.querySelector('[data-archive-preview-position]');
    var previewViews = plate.querySelector('[data-archive-preview-views]');
    var previewVendor = plate.querySelector('[data-archive-preview-vendor]');
    var previewTitle = plate.querySelector('[data-archive-preview-title]');
    var previewSeason = plate.querySelector('[data-archive-preview-season]');
    var previewLine = plate.querySelector('[data-archive-preview-line]');
    var previewType = plate.querySelector('[data-archive-preview-type]');
    var previewExcerpt = plate.querySelector('[data-archive-preview-excerpt]');
    var viewLabel = register.getAttribute('data-archive-view-label') || 'view';
    var viewsLabel = register.getAttribute('data-archive-views-label') || 'views';
    var controller = new AbortController();
    var signal = controller.signal;
    var visibleRecords = new Set();
    var previewCache = new Map();
    var activeIndex = -1;
    var scrollIndex = 0;
    var pointerIndex = null;
    var focusIndex = null;
    var imageToken = 0;
    var destroyed = false;

    var leavePreviewLayout = function (event) {
      if (event.matches) return;
      var destroy = root._archiveDestroy;
      if (destroy) destroy();
      initArchive(root);
    };
    if (previewLayout.addEventListener) {
      previewLayout.addEventListener('change', leavePreviewLayout);
    } else if (previewLayout.addListener) {
      previewLayout.addListener(leavePreviewLayout);
    }

    function recordIndex(record) {
      if (!record) return -1;
      var index = Number(record.getAttribute('data-archive-index'));
      return Number.isInteger(index) && index >= 0 && index < records.length ? index : -1;
    }

    function recordFromTarget(target) {
      if (!target || typeof target.closest !== 'function') return null;
      var record = target.closest('[data-archive-record]');
      return record && register.contains(record) ? record : null;
    }

    function updateOptional(node, value) {
      if (!node) return;
      var nextValue = String(value || '').trim();
      node.textContent = nextValue;
      node.hidden = !nextValue;
    }

    function trimPreviewCache() {
      while (previewCache.size > PREVIEW_CACHE_LIMIT) {
        var oldestSource = previewCache.keys().next().value;
        var oldestLoader = previewCache.get(oldestSource);
        if (oldestLoader && !oldestLoader.complete) {
          oldestLoader.onload = null;
          oldestLoader.onerror = null;
          oldestLoader.removeAttribute('src');
        }
        previewCache.delete(oldestSource);
      }
    }

    function commitPreviewImage(src, alt, token) {
      if (destroyed || token !== imageToken) return;
      previewImage.removeAttribute('srcset');
      previewImage.removeAttribute('sizes');
      previewImage.removeAttribute('width');
      previewImage.removeAttribute('height');
      previewImage.setAttribute('src', src);
      previewImage.setAttribute('alt', alt || '');
      previewImage.hidden = false;
      previewEmpty.hidden = true;
      plateImageFrame.removeAttribute('data-archive-image-loading');
    }

    function updatePreviewImage(record) {
      imageToken += 1;
      var token = imageToken;
      var src = record.getAttribute('data-archive-preview-src') || '';
      var alt = record.getAttribute('data-archive-preview-alt') || '';

      if (!src) {
        previewImage.hidden = true;
        previewImage.removeAttribute('src');
        previewImage.setAttribute('alt', '');
        previewEmpty.hidden = false;
        plateImageFrame.removeAttribute('data-archive-image-loading');
        return;
      }

      if (previewImage.getAttribute('src') === src) {
        previewImage.setAttribute('alt', alt);
        previewImage.hidden = false;
        previewEmpty.hidden = true;
        plateImageFrame.removeAttribute('data-archive-image-loading');
        return;
      }

      plateImageFrame.setAttribute('data-archive-image-loading', '');
      var cached = previewCache.get(src);
      if (cached && cached.complete && cached.naturalWidth > 0) {
        commitPreviewImage(src, alt, token);
        return;
      }

      var loader = cached || new Image();
      previewCache.set(src, loader);
      trimPreviewCache();

      var finish = function () {
        loader.onload = null;
        loader.onerror = null;
        if (typeof loader.decode === 'function') {
          loader.decode().then(
            function () { commitPreviewImage(src, alt, token); },
            function () { commitPreviewImage(src, alt, token); }
          );
          return;
        }
        commitPreviewImage(src, alt, token);
      };

      loader.onload = finish;
      loader.onerror = function () {
        loader.onload = null;
        loader.onerror = null;
        previewCache.delete(src);
        if (destroyed || token !== imageToken) return;
        previewImage.hidden = true;
        previewImage.removeAttribute('src');
        previewImage.setAttribute('alt', '');
        previewEmpty.hidden = false;
        plateImageFrame.removeAttribute('data-archive-image-loading');
      };
      if (!cached) {
        loader.decoding = 'async';
        loader.src = src;
      } else if (loader.complete && loader.naturalWidth > 0) {
        finish();
      }
    }

    function setActive(index) {
      if (!Number.isInteger(index) || index < 0 || index >= records.length) return;
      var record = records[index];

      if (activeIndex !== index) {
        if (activeIndex >= 0) records[activeIndex].classList.remove('is-active');
        record.classList.add('is-active');
        activeIndex = index;
      }

      updateOptional(previewPosition, record.getAttribute('data-archive-position'));
      updateOptional(previewVendor, record.getAttribute('data-archive-vendor'));
      updateOptional(previewTitle, record.getAttribute('data-archive-title'));
      updateOptional(previewSeason, record.getAttribute('data-archive-season'));
      updateOptional(previewLine, record.getAttribute('data-archive-line'));
      updateOptional(previewType, record.getAttribute('data-archive-type'));

      var excerpt = record.querySelector('[data-archive-record-excerpt]');
      updateOptional(previewExcerpt, excerpt ? excerpt.textContent : '');

      if (previewViews) {
        var imageCount = Number(record.getAttribute('data-archive-image-count')) || 0;
        previewViews.textContent = imageCount > 0
          ? imageCount + ' ' + (imageCount === 1 ? viewLabel : viewsLabel)
          : '';
        previewViews.hidden = imageCount < 1;
      }

      updatePreviewImage(record);
    }

    function currentOverride() {
      if (focusIndex !== null) return focusIndex;
      if (pointerIndex !== null) return pointerIndex;
      return scrollIndex;
    }

    function chooseScrollRecord() {
      if (!visibleRecords.size) return;
      var centre = window.innerHeight * .4;
      var candidates = Array.from(visibleRecords);
      candidates.sort(function (a, b) {
        var aRect = a.getBoundingClientRect();
        var bRect = b.getBoundingClientRect();
        var aDistance = Math.abs(aRect.top + (aRect.height / 2) - centre);
        var bDistance = Math.abs(bRect.top + (bRect.height / 2) - centre);
        return aDistance - bDistance;
      });
      var index = recordIndex(candidates[0]);
      if (index < 0) return;
      scrollIndex = index;
      if (focusIndex === null && pointerIndex === null) setActive(scrollIndex);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visibleRecords.add(entry.target);
        else visibleRecords.delete(entry.target);
      });
      chooseScrollRecord();
    }, {
      root: null,
      rootMargin: '-18% 0px -55% 0px',
      threshold: [0, .01, .5]
    });

    records.forEach(function (record) { observer.observe(record); });

    register.addEventListener('pointerover', function (event) {
      var record = recordFromTarget(event.target);
      if (!record || record.contains(event.relatedTarget)) return;
      var index = recordIndex(record);
      if (index < 0) return;
      pointerIndex = index;
      setActive(currentOverride());
    }, { signal: signal });

    register.addEventListener('pointerout', function (event) {
      var record = recordFromTarget(event.target);
      if (!record || record.contains(event.relatedTarget)) return;
      pointerIndex = null;
      setActive(currentOverride());
    }, { signal: signal });

    register.addEventListener('focusin', function (event) {
      var record = recordFromTarget(event.target);
      var index = recordIndex(record);
      if (index < 0) return;
      focusIndex = index;
      setActive(index);
    }, { signal: signal });

    register.addEventListener('focusout', function (event) {
      var record = recordFromTarget(event.target);
      if (!record || record.contains(event.relatedTarget)) return;
      var nextRecord = recordFromTarget(event.relatedTarget);
      focusIndex = nextRecord ? recordIndex(nextRecord) : null;
      setActive(currentOverride());
    }, { signal: signal });

    setActive(0);
    register.setAttribute('data-archive-enhanced', '');

    root._archiveDestroy = function () {
      destroyed = true;
      imageToken += 1;
      controller.abort();
      if (previewLayout.removeEventListener) previewLayout.removeEventListener('change', leavePreviewLayout);
      else if (previewLayout.removeListener) previewLayout.removeListener(leavePreviewLayout);
      observer.disconnect();
      visibleRecords.clear();
      previewCache.forEach(function (loader) {
        if (!loader || loader.complete) return;
        loader.onload = null;
        loader.onerror = null;
        loader.removeAttribute('src');
      });
      previewCache.clear();
      records.forEach(function (record) { record.classList.remove('is-active'); });
      register.removeAttribute('data-archive-enhanced');
      root._archiveDestroy = null;
    };
  }

  function initWithin(scope) {
    if (!scope) return;
    var root = scope.matches && scope.matches('[data-archive-shell]')
      ? scope
      : scope.querySelector && scope.querySelector('[data-archive-shell]');
    if (root) initArchive(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-archive-shell]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-archive-shell]');
    if (root && root._archiveDestroy) root._archiveDestroy();
  });
})();
